import { MouseEvent } from 'react'
import clsx from 'clsx'
import { Button, Divider, Icon, Modal, Text } from 'components/common'
import { CustomizedModalProps } from './types'

export interface BookingCreateModalProps extends CustomizedModalProps {}

interface ItemProps {
  title: string
  description: string
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
}

const Item = ({ title, description, onClick }: ItemProps): JSX.Element => (
  <>
    <div
      className={clsx(
        'cursor-pointer',
        'flex',
        'justify-between',
        'items-center'
      )}
      role="button"
      onClick={onClick}
    >
      <div>
        <div>
          <Text strong>{title}</Text>
        </div>
        <div>
          <Text mute>{description}</Text>
        </div>
      </div>
      <div>
        <Icon.RightOutlined />
      </div>
    </div>
  </>
)

export const BookingCreateModal = ({
  cancelButtonProps = {},
  onCancel,
  ...rest
}: BookingCreateModalProps): JSX.Element => (
  <>
    <Modal
      title="予約を作成する"
      footer={[
        <Button {...cancelButtonProps} onClick={onCancel}>
          キャンセル
        </Button>,
      ]}
      {...rest}
    >
      <Item
        title={'下書きを作成する'}
        description={
          '下書きは金額を確定させることで、下書きから予約が作成されます。'
        }
      />

      <Divider space="large" />

      <Item
        title="下書きを一括作成する"
        description="複数の下書きを一括で作成します。"
      />
    </Modal>
  </>
)
